export function uniq(array) {
    return array.filter((x, i, arr) => arr.indexOf(x) === i);
}
//# sourceMappingURL=uniq.js.map